"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cloneDeep = require("lodash.clonedeep");

var isEqual = require("lodash.isequal");

var AttributeMap;

(function (AttributeMap) {
  function compose() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var keepNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (_typeof(a) !== 'object') {
      a = {};
    }

    if (_typeof(b) !== 'object') {
      b = {};
    }

    var attributes = cloneDeep(b);

    if (!keepNull) {
      attributes = Object.keys(attributes).reduce(function (copy, key) {
        if (attributes[key] != null) {
          copy[key] = attributes[key];
        }

        return copy;
      }, {});
    }

    for (var key in a) {
      if (a[key] !== undefined && b[key] === undefined) {
        attributes[key] = a[key];
      }
    }

    return Object.keys(attributes).length > 0 ? attributes : undefined;
  }

  AttributeMap.compose = compose;

  function diff() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_typeof(a) !== 'object') {
      a = {};
    }

    if (_typeof(b) !== 'object') {
      b = {};
    }

    var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attrs, key) {
      if (!isEqual(a[key], b[key])) {
        attrs[key] = b[key] === undefined ? null : b[key];
      }

      return attrs;
    }, {});
    return Object.keys(attributes).length > 0 ? attributes : undefined;
  }

  AttributeMap.diff = diff;

  function invert() {
    var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    attr = attr || {};
    var baseInverted = Object.keys(base).reduce(function (memo, key) {
      if (base[key] !== attr[key] && attr[key] !== undefined) {
        memo[key] = base[key];
      }

      return memo;
    }, {});
    return Object.keys(attr).reduce(function (memo, key) {
      if (attr[key] !== base[key] && base[key] === undefined) {
        memo[key] = null;
      }

      return memo;
    }, baseInverted);
  }

  AttributeMap.invert = invert;

  function transform(a, b) {
    var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (_typeof(a) !== 'object') {
      return b;
    }

    if (_typeof(b) !== 'object') {
      return undefined;
    }

    if (!priority) {
      return b; // b simply overwrites us without priority
    }

    var attributes = Object.keys(b).reduce(function (attrs, key) {
      if (a[key] === undefined) {
        attrs[key] = b[key]; // null is a valid value
      }

      return attrs;
    }, {});
    return Object.keys(attributes).length > 0 ? attributes : undefined;
  }

  AttributeMap.transform = transform;
})(AttributeMap || (AttributeMap = {}));

exports["default"] = AttributeMap;